import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TCategory, TState } from "./types";

export const initialState: TState = {
  areas: [],
  categories: [],

  hide_logo: false,

  address: [37.55663871622735, 55.737595055662936],

  loading: false,
  help_type: null,
  parent_category_id: null,
};

const slice = createSlice({
  name: "map",
  initialState,
  reducers: (create) => ({
    setAreas: create.reducer((state, { payload }: PayloadAction<[]>) => {
      state.areas = payload;
    }),

    setAddress: create.reducer(
      (state, { payload }: PayloadAction<number[]>) => {
        state.address = payload;
      },
    ),

    setHelpType: create.reducer(
      (state, { payload }: PayloadAction<string[] | null>) => {
        state.help_type = payload;
      },
    ),

    setCategories: create.reducer(
      (state, { payload }: PayloadAction<TCategory[]>) => {
        state.categories = payload;
      },
    ),

    setParentId: create.reducer(
      (state, { payload }: PayloadAction<string[] | null>) => {
        state.parent_category_id = payload;
      },
    ),

    setHideLogo: create.reducer(
      (state, { payload }: PayloadAction<boolean>) => {
        state.hide_logo = payload;
      },
    ),
  }),
});

export const { setCategories, setHelpType, setParentId, setAreas, setAddress, setHideLogo } =
  slice.actions;

export default slice.reducer;
